const settled = promise =>
  promise.then(
    value => ({ status: "fulfilled", value }),
    reason => ({ status: "rejected", reason })
  );

const responseData = result =>
  result.status === "fulfilled" && result.value
    ? result.value.data || []
    : [];

export const isConcreteShopeeShopId = shopId => {
  const value = String(shopId || "").trim();
  return /^\d+$/.test(value) && !/^0+$/.test(value);
};

const enabledFlag = value =>
  value === true ||
  value === 1 ||
  String(value || "").trim().toLowerCase() === "true" ||
  String(value || "").trim() === "1";

export const isPrimaryShopeeShop = shop =>
  Boolean(
    shop &&
      [shop.is_primary, shop.is_main, shop.is_default, shop.primary].some(
        enabledFlag
      )
  );

export const defaultShopeeListingShopId = (shops, preferredShopId) => {
  const available = (Array.isArray(shops) ? shops : []).filter(
    shop =>
      shop &&
      shop.is_active !== false &&
      isConcreteShopeeShopId(shop.shop_id)
  );
  const preferred = available.find(
    shop => String(shop.shop_id) === String(preferredShopId || "")
  );
  const selected = preferred || available.find(isPrimaryShopeeShop) || available[0];
  return selected ? String(selected.shop_id) : "";
};

export const shopeeEditorErrorMessage = error =>
  (error &&
    error.response &&
    error.response.data &&
    error.response.data.error &&
    error.response.data.error.message) ||
  (error && error.message) ||
  "Không tải được dữ liệu Shopee";

export async function loadShopeeListingEditorData({
  api,
  shopId,
  isUpdate,
  itemId,
  signal
}) {
  if (!isConcreteShopeeShopId(shopId)) {
    return {
      categories: [],
      logistics: [],
      primary: [],
      errors: [{ source: "shop", message: "INVALID_SHOP" }],
      primaryFailed: true
    };
  }

  const primaryRequest = isUpdate
    ? api.listing(shopId, itemId, signal)
    : api.catalogCandidates({ page_size: 100 }, signal);
  const results = await Promise.all([
    settled(api.catalogCategories(shopId, signal)),
    settled(api.catalogLogistics(shopId, signal)),
    settled(primaryRequest)
  ]);
  const sources = ["categories", "logistics", isUpdate ? "listing" : "candidates"];
  const errors = results.reduce((values, result, index) => {
    if (result.status === "rejected") {
      values.push({
        source: sources[index],
        message: shopeeEditorErrorMessage(result.reason)
      });
    }
    return values;
  }, []);

  return {
    categories: responseData(results[0]),
    logistics: responseData(results[1]),
    primary: responseData(results[2]),
    errors,
    primaryFailed: results[2].status === "rejected"
  };
}
